import styled from "styled-components";

export const ProjectCardLayout = styled.div<{
  hasGitProjectAccess: boolean;
}>`
  max-width: 100%;

  margin: 0;
  cursor: pointer;
  border-radius: 2px;
  width: 100%;
  background-color: var(--section-snow-background-color, var(--snow));
  .row {
    color: var(--section-ebony-light-color, var(--ebony-light));
    &:hover .cell.cell-project {
      color: var(--section-color-primary-600-color, var(--color-primary-600));
    }
  }

  ${props =>
    props.hasGitProjectAccess &&
    `&:hover,
  &:focus {
    box-shadow: ${
      props.theme.name === "dark"
        ? "0px 6px 44px #01001A"
        : "0 6px 44px rgba(152, 160, 171, 0.6)"
    };
   
  }`};
  a {
    text-decoration: none;
  }
`;

export const NoAccessWrapper = styled.div`
  cursor: auto;
`;
